const loadAuthSuiteStore = (store, config) => {
    if (config.enabled && !store.hasModule('authSuite')) {
        import(
            /* webpackChunkName: "auth-suite-store" */
            'vue/stores/modules/AuthSuite/AuthSuiteStore'
        ).then((module) => {
            const AuthSuiteStore = module.default;
            store.registerModule('authSuite', AuthSuiteStore);

            store.dispatch('authSuite/loadAuthSuite', config);
        });
    }
};

export { loadAuthSuiteStore };
